module.exports = __webpack_public_path__ + "static/media/check-red.01b2e6ea.svg";